import styled from 'styled-components';
import variables from '@ingka/variables/design-tokens';
import cssIngka from '@ingka/variables/colours-css';
import Status from '@ingka/status';
import InlineMessage from '@ingka/inline-message';

export const InformationMessage = styled(InlineMessage)`
  margin-bottom: 1rem;
`;

export const StyledInformation = styled.div`
  margin: 0.5rem 0 1rem;
`;

export const DetailsSection = styled.div`
  padding: 1.5rem 0;

  h3 {
    margin-bottom: 1.25rem;
  }
`;

export const SubTotals = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 1.5rem 0;
`;

export const Total = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 1.5rem 0;
  font-weight: ${variables.fontWeightBold};
  span:last-child {
    font-size: 1.25rem;
  }
`;

export const FlexContainer = styled.div`
  display: flex;
  width: 100%;
  margin: 30px 0;
  flex-direction: column;
  ${`@media (min-width: ${variables.breakpointM}) {
  flex-direction: row;
  margin: 90px 0;
}`}
`;

export const SummaryLeftCol = styled.div`
  width: 100%;
  ${`@media (min-width: ${variables.breakpointM}) {
  width: 30%;
}`}
`;

export const SummaryRightCol = styled.div`
  width: 100%;
  ${`@media (min-width: ${variables.breakpointM}) {
  margin-top: 20px;
  width: 70%;
}`}
`;

export const Wrapper = styled.div`
  ${`@media (min-width: ${variables.breakpointM}) {
  max-width: 256px;
  margin: 0 auto 0 0;
}`}
`;

export const SummaryDivider = styled.div`
  ${`@media (min-width: ${variables.breakpointM}) {
  border-right: 1px solid ${cssIngka.colourNeutral3};
  margin: 0 105px;
}`}
`;

export const DeliveryStatusText = styled.h2.attrs({
  as: 'h2',
  className: 'h2',
})`
  display: flex;
`;

export const StyledStatus = styled(Status)`
  margin-inline-start: 8px;
`;

export const DeliveryStatus = styled.div`
  display: flex;
`;
